import { ClipLoader } from "react-spinners"
import { css } from "@emotion/react";
import { useContext } from "react";
import GeneralContext from '../../../context/GeneralContext/GeneralContext'

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`
export default function Loader (props){

    const {
        show_loading
    } = useContext(GeneralContext)


    return (
        show_loading
          ?
          <div>
            <div className="fixed flex items-center justify-center z-9998 w-full h-full bg-appian-blue opacity-10" />

            <div className="fixed flex items-center justify-center z-9999 w-full h-full">
              <ClipLoader color={"#fff"} loading={show_loading} css={override} size={30} />
            </div>
          </div>
          :
          null
    )
}